'use strict'

const init = () => {
    const links = document.querySelectorAll('a[href^="javascript:linkTo_UnCryptMailto"]')

    links.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault()

            const href = link.getAttribute('href')
            const match = href.match(/linkTo_UnCryptMailto\(\s*['"]([^'"]+)['"]\s*,\s*([+-]?\d+)\s*\)/)

            if (match && typeof window.linkTo_UnCryptMailto === 'function') {
                const enc = match[1]
                const shift = parseInt(match[2], 10)
                window.linkTo_UnCryptMailto(enc, shift)
            }
        })
    })
}

export default { init }
